
import React from 'react';
import './GamePreview.scss';
import { Link } from 'react-router-dom';
import Money from '../util/Money.jsx';
import { formatTimeFromSeconds } from '../util/DateTimeFormat.js';

export default function GamePreview(props) {
    const {
        gameSnap,
        readOnly,
    } = props;

    const data = gameSnap.data();

    const renderPreview = () => {
        return (
            <div className='game-preview' >
                <div className='team-container'>
                    <div className='team away'>
                        {data.away_team.full_name}
                    </div>
                    <div className='team home'>
                        {data.home_team.full_name}
                    </div>
                    <div className="time">
                        {formatTimeFromSeconds(data.start_time.seconds)}
                    </div>
                </div>
                <div className='last-trade'>
                    <Money value={data.last_trade} />
                </div>
            </div>
        );
    };

    if (readOnly) {
        return renderPreview();
    }

    return (
        <Link to={`/r/game/${props.gameSnap.id}`} >
            {renderPreview()}
        </Link>
    );
}
